/* 2026-11-03: shared accessible carousel controls for product detail galleries. */
(() => {
  'use strict';

  const ROTATION_DELAY = 5500;
  const gallerySelector = '.ls-pdp-gallery, .ls-product-inquiry__gallery, [data-ls-gallery]';
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  const createArrow = (direction, label) => {
    const button = document.createElement('button');
    button.type = 'button';
    button.className = `ls-product-gallery-autoplay__arrow ls-product-gallery-autoplay__arrow--${direction}`;
    button.setAttribute('aria-label', label);
    button.innerHTML = direction === 'previous'
      ? '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="m15 18-6-6 6-6"/></svg>'
      : '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="m9 18 6-6-6-6"/></svg>';
    return button;
  };

  function setupGallery(root) {
    if (root.dataset.galleryAutoplayReady === 'true') return;

    let mainImage;
    let frame;
    let controls;
    let sourceFor;
    let altFor;
    let nativeButtonControls = true;

    if (root.matches('[data-ls-gallery]')) {
      mainImage = root.querySelector('[data-ls-gallery-main]');
      frame = root;
      controls = [...root.querySelectorAll('[data-ls-pdp-slide]')];
      sourceFor = (item) => item.dataset.src;
      altFor = (item) => item.dataset.alt;
      nativeButtonControls = false;
    } else if (root.matches('.ls-product-inquiry__gallery')) {
      mainImage = root.querySelector('[data-inquiry-main-image]');
      frame = mainImage?.closest('.ls-product-inquiry__main-image');
      controls = [...root.querySelectorAll('[data-inquiry-thumbnail]')];
      sourceFor = (item) => item.dataset.fullSrc;
      altFor = (item) => item.dataset.imageAlt;
    } else {
      mainImage = root.querySelector('#main-product-image');
      frame = mainImage?.closest('.ls-pdp-image');
      controls = [...root.querySelectorAll('button[data-gallery]')];
      sourceFor = (item) => item.dataset.gallery;
      altFor = (item) => item.dataset.alt;
    }

    if (!mainImage || !frame || !controls || controls.length < 2) return;
    root.dataset.galleryAutoplayReady = 'true';
    root.dataset.galleryAutoplay = 'true';
    frame.classList.add('ls-product-gallery-autoplay__frame');

    let index = controls.findIndex((item) => item.getAttribute('aria-pressed') === 'true' || item.classList.contains('is-active'));
    if (index < 0) index = 0;

    const previous = createArrow('previous', 'Show previous product image');
    const next = createArrow('next', 'Show next product image');
    frame.append(previous, next);

    let timer = 0;
    let hovered = false;
    let focused = false;

    const cancel = () => {
      window.clearTimeout(timer);
      timer = 0;
    };

    const schedule = () => {
      cancel();
      if (hovered || focused || reducedMotion.matches || document.hidden) return;
      timer = window.setTimeout(() => {
        activate(index + 1, false);
        schedule();
      }, ROTATION_DELAY);
    };

    const updateControls = (activeIndex) => {
      controls.forEach((item, itemIndex) => {
        const active = itemIndex === activeIndex;
        if (item.hasAttribute('aria-pressed')) item.setAttribute('aria-pressed', String(active));
        item.classList.toggle('is-active', active);
      });
    };

    function activate(targetIndex, restartTimer = true) {
      index = (targetIndex + controls.length) % controls.length;
      const item = controls[index];
      const source = sourceFor(item);
      const alt = altFor(item) || '';

      if (nativeButtonControls) item.click();
      if (source) mainImage.src = source;
      mainImage.alt = alt;
      updateControls(index);
      root.dataset.activeGallerySlide = String(index + 1);
      if (restartTimer) schedule();
    }

    controls.forEach((item, itemIndex) => {
      item.addEventListener('click', () => {
        index = itemIndex;
        const source = sourceFor(item);
        if (source) mainImage.src = source;
        mainImage.alt = altFor(item) || '';
        updateControls(index);
        root.dataset.activeGallerySlide = String(index + 1);
        schedule();
      });
    });

    previous.addEventListener('click', () => activate(index - 1));
    next.addEventListener('click', () => activate(index + 1));
    root.addEventListener('pointerenter', () => { hovered = true; cancel(); });
    root.addEventListener('pointerleave', () => { hovered = false; schedule(); });
    root.addEventListener('focusin', () => { focused = true; cancel(); });
    root.addEventListener('focusout', () => {
      window.setTimeout(() => {
        focused = root.contains(document.activeElement);
        schedule();
      }, 0);
    });
    document.addEventListener('visibilitychange', schedule);
    reducedMotion.addEventListener?.('change', schedule);
    schedule();
  }

  function init() {
    document.querySelectorAll(gallerySelector).forEach(setupGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
